import instance from './instance'
import API from '@api'
import store from "@store"

//包裹请求方法的容器
const http = {};

//service循环遍历输出不同的请求方法
for (let [key, api] of Object.entries(API)) {
  http[key] = (params={}, config={}, isFormData=false) => {
    /*请求中添加默认参数uid,agentId*/
    if (store.state.token) {
      params.uid = store.state.uid;
    }
    let url = dealUrl(api.url, params);
    let newParams = dealParams(params, isFormData);
    //不同请求的判断
    if (api.method === 'put' || api.method === 'post' || api.method === 'patch') {
      return instance[api.method](url, newParams, config);
    } else if (api.method === 'delete' || api.method === 'get') {
      config.params = newParams;
      return instance[api.method](url, config);
    }
  }
}

// 处理URL
function dealUrl(url, params) {
  let newUrl = url;
  if (params.optionId) {
    newUrl += "/" + params.optionId;
    delete params.optionId;
  } else if (params.newUrl) {
    newUrl = params.newUrl;
    delete params.newUrl;
  }
  return newUrl;
}

// 处理params
function dealParams(params, isFormData) {
  let newParams = params;
  //content-type是否是form-data的判断
  if (isFormData) {
    newParams = new FormData();
    for (let [key, val] of Object.entries(params)) {
      newParams.append(key, val)
    }
  }
  return newParams
}

export default http;
